<template>
  <section :class="$style.root">
    <slot />
  </section>
</template>

<script>
export default {
  name: 'ContentBlock',
}
</script>

<style lang="scss" module>
@import '~@/ui-kit/_theme/main.scss';

.root {
  background: $bg-primary;
  border-radius: $border-radius-block;
  padding: $gap-l;
  box-shadow: $shadow-block;
  border: 1px solid $line-light-color;
}
</style>
